import { render, staticRenderFns } from "./PersonForm.component.vue?vue&type=template&id=62956500"
import script from "./PersonForm.component.vue?vue&type=script&lang=js"
export * from "./PersonForm.component.vue?vue&type=script&lang=js"
import style0 from "./PersonForm.component.vue?vue&type=style&index=0&id=62956500&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports